import React, {Component} from 'react';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';
import Const from 'constants';

class SelectKeyPosition extends Component {
    getOptions() {
        const {positions} = this.props;

        const options = {'': 'Position'};

        positions
            .filter((position) => !inArray(position, Const.POSITION_STACK_AVOID_POSITIONS))
            .map((position) => (options[position] = position));

        return options;
    }
    render() {
        const {className} = this.props;

        return (
            <SimpleSelect
                className={className}
                value={this.props.value}
                options={this.getOptions()}
                onChange={this.props.onChange}
            />
        );
    }
}

export default SelectKeyPosition;
